import {IArrayCondition} from './array-operators';
import {IComparisonCondition} from './comparison-operators';

export enum logicalOperators {
    All = 'All',
    Any = 'Any'
}

export interface ILogicalCondition {
    operator: logicalOperators;
    conditions: (IArrayCondition | IComparisonCondition | ILogicalCondition)[];
}
